export default __webpack_public_path__ + "media/jonathanVid.95d9b8ef.mp4";